module.exports = __webpack_public_path__ + "img/compare-trans.b8aac2c1.svg";